import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CalculoCartaCreditoVO } from '../shared/model/calculo-carta-credito-vo.model';
import { ParametroCartaCredito } from '../shared/model/parametro-carta-credito.model';
import { CartaCreditoAnualForm } from '../carta-credito/gerar-carta-credito/calculo-carta-credito/calculo-carta-anual/carta-credito-anual.form';
import { CalculoCartaAnualConfig } from '../shared/model/calculo-carta-anual-config.model';

@Injectable({
  providedIn: 'root'
})
export class CalculoCartaCreditoAnualService {

  private calculoCarta: CalculoCartaCreditoVO;

  constructor() {
    this.calculoCarta = new CalculoCartaCreditoVO();
  }

  calcularCreditoFinanceiro(cartaForm: CartaCreditoAnualForm, parametros: ParametroCartaCredito,
    paMpd: number ) {
      const  configRegiaoSudanSudene: CalculoCartaAnualConfig = this.obterConfiguracoesCalculoSudanSudene(cartaForm, parametros);
      const  configRegiaoDemaisRegioes: CalculoCartaAnualConfig = this.obterConfiguracoesCalculoDemaisRegioes(cartaForm, parametros);
      this.obterCalculosCartaCredito(configRegiaoSudanSudene, paMpd);
      this.obterCalculosCartaCredito(configRegiaoDemaisRegioes, paMpd);
  }

  obterConfiguracoesCalculoSudanSudene(cartaForm: CartaCreditoAnualForm, parametros: ParametroCartaCredito): CalculoCartaAnualConfig {
    let configCalculo: CalculoCartaAnualConfig = new CalculoCartaAnualConfig();
    configCalculo.form = cartaForm.sudanSudene;
    configCalculo.formExcedente = cartaForm.excedente;
    configCalculo.multiplicador = parametros.multiplicadorSudanSudeneCentroOeste;
    configCalculo.percentual = parametros.percentualSudanSudeneCentroOeste;
    configCalculo.denominadorPdic = parametros.denominadorPdicSudanSudeneCentroOeste;
    return configCalculo;
  }

  obterConfiguracoesCalculoDemaisRegioes(cartaForm: CartaCreditoAnualForm, parametros: ParametroCartaCredito): CalculoCartaAnualConfig {
    let configCalculo: CalculoCartaAnualConfig = new CalculoCartaAnualConfig();
    configCalculo.form = cartaForm.demaisRegioes;
    configCalculo.formExcedente = cartaForm.excedente;
    configCalculo.multiplicador = parametros.multiplicadorDemaisRegioes;
    configCalculo.percentual = parametros.percentualDemaisRegioes;
    configCalculo.denominadorPdic = parametros.denominadorPdicDemaisRegioes;
    return configCalculo;
  }

  obterCalculosCartaCredito(configRegiao: CalculoCartaAnualConfig, paMpd: number) {
    const valorInvestimentoPdim = configRegiao.form.get('investimentoPdim')
      .get('valor').value;

    const faturamentoProduto = configRegiao.form.get('faturamentoTotalProduto')
      .get('valor').value

    this.calculoCarta.valorCredito = 0;
    if (faturamentoProduto !== null && faturamentoProduto !== 0) {

      if (valorInvestimentoPdim) {
        this.calculoCarta.valorCredito += this.calcularValorCredito(valorInvestimentoPdim,configRegiao, paMpd);
      }
      this.calculoCarta.valorLimiteCredito = (faturamentoProduto * configRegiao.percentual / 100);
      this.calculoCarta.valorExcedente = 0;
      this.calculoCarta.valorExcedenteAcumulado = 0;
      this.calculoCarta.valorRemanescente = 0;
      this.calculoCarta.valorRemanescenteAcumulado = 0
      this.verificarExcedenteAcumuladoUtilizado(configRegiao.formExcedente);
      this.calculoCarta = this.calcularValores(this.calculoCarta);
      this.definirValoresFormularios(configRegiao.form);
    } else {
        this.resetarValores(configRegiao.form, faturamentoProduto);
        this.definirValoresFormularios(configRegiao.form);
    }
  }

  calcularValorCredito(valorInvestimentoPdim: number, configRegiao:CalculoCartaAnualConfig , paMpd: number) {
    const valorInvestimentoPdic = configRegiao.form.get('investimentoPdic').get('valor').value;
    let valorPdicCalculado = 0;
    if(valorInvestimentoPdic && valorInvestimentoPdic > 0) {
      valorPdicCalculado = valorInvestimentoPdic / configRegiao.denominadorPdic;
    }
    return valorInvestimentoPdim * configRegiao.multiplicador * paMpd
          + valorInvestimentoPdim + valorPdicCalculado;
  }

  verificarExcedenteAcumuladoUtilizado(acumulado: FormGroup) {
    const valorExcedenteUtilizadoNormal = acumulado.get('valorExcedenteUtilizado')
      .get('valor').value;

    if (valorExcedenteUtilizadoNormal) {
      this.calculoCarta.valorCredito += valorExcedenteUtilizadoNormal;
    }

  }

  calcularValores(calculoCarta: CalculoCartaCreditoVO) {

    let valorCalculado = calculoCarta.valorCredito - calculoCarta.valorLimiteCredito

    if (valorCalculado > 0) {
      calculoCarta.valorExcedente = valorCalculado;
      calculoCarta.valorExcedenteAcumuladoCalculado = calculoCarta.valorExcedenteAcumulado + calculoCarta.valorExcedente;

      calculoCarta.valorCredito = calculoCarta.valorLimiteCredito;
    } else {
      calculoCarta.valorExcedenteAcumuladoCalculado = calculoCarta.valorExcedenteAcumulado
       + calculoCarta.valorExcedente
      if (calculoCarta.valorExcedenteAcumulado > 0) {
        calculoCarta.valorCredito = calculoCarta.valorCredito + calculoCarta.valorExcedenteAcumulado;
        calculoCarta.valorExcedenteAcumulado = 0;

        this.calcularValores(calculoCarta);
      }

      this.calculoCarta.valorRemanescente = Math.abs(valorCalculado);

    }
    return calculoCarta;
  }

  definirValoresFormularios(formRegiao: FormGroup) {
    formRegiao.get('valorCredito').get('valor').patchValue(this.calculoCarta.valorCredito);
    formRegiao.get('limiteCredito').get('valor').patchValue(this.calculoCarta.valorLimiteCredito);
    formRegiao.get('valorPDIExcedente').get('valor').patchValue(this.calculoCarta.valorExcedente);
  }

  resetarValores(formRegiao: FormGroup, faturamentoProduto: number) {
    formRegiao.get('valorCredito').get('valor').setValue(0);
    this.calculoCarta.valorCredito = 0;
    formRegiao.get('valorPDIExcedente').get('valor').setValue(0);
    this.calculoCarta.valorExcedente = 0;

    if(!faturamentoProduto) {
      this.calculoCarta.valorLimiteCredito = 0;
      formRegiao.get('limiteCredito').get('valor').setValue(0);
    }
  }

  obterValorLimiteCredito(formGroup: FormGroup, percentual: number) {
    this.calculoCarta.valorLimiteCredito = (formGroup.get('faturamentoTotalProduto')
      .get('valor').value * percentual / 100);
    formGroup.get('limiteCredito').get('valor').patchValue(this.calculoCarta.valorLimiteCredito);
  }

}
